import { angularJsApp } from "../app";
import { AppComponentsEnum } from "../app.model";

class Component {
  tipus;
  
  constructor(
    private $scope,
    private $uibModalInstance,
    private tipusSE
  ) { 
    this.tipus = this.tipusSE;
  }

  $onInit() {
    this.setupListeners();
  }

  private setupListeners() {
    this.$scope.ok = () => {
      this.$uibModalInstance.close();
    }
  }
}

const component: ng.IComponentOptions = {
  bindings: {},
  template: `
    <div class="modal-header">
      <h3 class="modal-title">Centres adscrits als serveis educatius</h3>
    </div>
    <div class="modal-body">
      <div ng-if="$ctrl.tipus == 42 || $ctrl.tipus == 45">
        <h4 class=modal-title align="center">
          Aquest servei educatiu s'imparteix a tots els centres de Catalunya
        </h4>
      </div>
      <div ng-if="$ctrl.tipus == 43">
        <h4 class=modal-title align="center">
          Aquest servei educatiu s'imparteix a tot l'àmbit territorial
        </h4>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-gene" type="button" ng-click="$ctrl.ok()">D'acord</button>
    </div>
  `,
  controller: Component,
};

angularJsApp.component(AppComponentsEnum.CENTRES_SE_TERRITORI, component);
